import './es.number.constructor-f2ac18e9.js';
import './index-f674799c.js';
import './es.string.trim-1d1c26df.js';
import { toRefs, ref, watch, computed, onMounted, resolveComponent, resolveDirective, openBlock, createElementBlock, normalizeClass, withDirectives, createElementVNode, createCommentVNode, createVNode, vShow, toDisplayString, vModelText, pushScopeId, popScopeId } from 'vue';
import { useField } from 'vee-validate';
import { u as useToggler } from './useToggler-e9ff86c0.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faQuestionCircle);
var script = {
  name: 'form-control-textarea',
  props: {
    name: {
      required: true,
      type: String
    },
    code: {
      required: false,
      type: String,
      default: ''
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      required: false,
      default: 5
    },
    textLimitConfig: {
      required: false,
      type: Object,
      default: function _default() {
        return {
          minCount: 0,
          maxCount: 0,
          // maxlength attribute will be filled with "524288" as default
          cLimitMinText: '',
          cLimitMaxText: '',
          showRemainingCharactersInfo: false,
          textLimitClass: 'text-warning'
        };
      }
    },
    additionalLabelClasses: {
      required: false,
      type: String,
      default: ''
    },
    shouldcache: {
      required: false,
      type: Boolean,
      default: false
    },
    prefixId: {
      required: false,
      type: String,
      default: 'wdw-form-attr'
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    defaultvalue: {
      required: false,
      type: String,
      default: ''
    },
    error: {
      required: false,
      type: String,
      default: ''
    },
    serverError: {
      required: false,
      type: String,
      default: ''
    },
    help: {
      required: false,
      type: String,
      default: ''
    },
    visibleIfResult: {
      required: false,
      type: Boolean,
      default: true
    },
    readonly: {
      required: false,
      type: Boolean
    },
    isPublic: {
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      required: false,
      default: false
    },
    reload: {
      type: Number,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  setup: function setup(props, context) {
    var _toRefs = toRefs(props),
        name = _toRefs.name,
        code = _toRefs.code,
        label = _toRefs.label,
        textLimitConfig = _toRefs.textLimitConfig,
        required = _toRefs.required,
        defaultvalue = _toRefs.defaultvalue,
        shouldcache = _toRefs.shouldcache,
        additionalLabelClasses = _toRefs.additionalLabelClasses,
        prefixId = _toRefs.prefixId,
        error = _toRefs.error,
        isPublic = _toRefs.isPublic,
        serverError = _toRefs.serverError,
        reset = _toRefs.reset;

    var _useToggler = useToggler(),
        shouldShowHelp = _useToggler.toggleValue,
        toggleHelpText = _useToggler.toggle;

    var remainingMaxCount = ref(textLimitConfig.value.maxCount);
    var remainingMinCount = ref(textLimitConfig.value.minCount);
    var warnMinTextlimit = ref(false);
    var warnMaxTextlimit = ref(false);
    var textareainput = ref(null); //+---------------------+
    //|    Other methods    |
    //+---------------------+

    function validate(value) {
      var finalvalue = value;

      if (typeof value == 'string') {
        finalvalue = value.trim();
      }

      var returnValue = {
        value: value,
        valueHuman: value,
        validated: true,
        name: name.value,
        code: code.value,
        type: 'text'
      };

      if (required.value) {
        returnValue.validated = finalvalue !== '';
      }

      if (shouldcache.value) {
        localStorage.setItem(name.value, returnValue.value);
      } // Emit event


      context.emit('validate', returnValue);
      return returnValue.validated ? true : error.value;
    }

    var _useField = useField(name, validate, {
      initialValue: defaultvalue.value
    }),
        errorMessage = _useField.errorMessage,
        value = _useField.value,
        triggerValidation = _useField.validate;

    function handleBlur(event) {
      triggerValidation();
    }

    watch(defaultvalue, function (nV) {
      value.value = nV;
    });

    function onTextEntered(event) {
      // Show warning on limit being reached
      if (value.value) {
        var tlc = textLimitConfig.value;
        var minCount = tlc.minCount;
        var maxCount = tlc.maxCount;

        if (maxCount && maxCount > 0) {
          remainingMaxCount.value = maxCount - value.value.length;
          warnMaxTextlimit.value = remainingMaxCount.value <= 0;
          textLimitConfig.value.showRemainingCharactersInfo = true;
        }

        if (minCount && minCount > 0) {
          remainingMinCount.value = minCount - value.value.length;
          warnMinTextlimit.value = remainingMinCount.value > 0;
          textLimitConfig.value.showRemainingCharactersInfo = true;
        }
      }

      if (event) {
        // Resize the textarea
        var target = event.target;

        if (target && target instanceof HTMLElement) {
          target.style.maxHeight = '400px';
          var cHeight = target.clientHeight;
          var sHeight = target.scrollHeight;

          if (cHeight < sHeight) {
            target.style.height = 25 + sHeight + 'px';
          }
        }
      }
    }

    function resetTextArea() {
      value.value = defaultvalue.value;
    }

    function setValue(string) {
      value.value = string;
      onTextEntered();
      validate(string);
    }

    context.expose({
      value: value,
      setValue: setValue,
      name: name
    }); //+---------------------+
    //|     computed()      |
    //+---------------------+

    var hasError = computed(function () {
      return errorMessage.value != undefined;
    });
    var hasServerError = computed(function () {
      return serverError.value != undefined && serverError.value !== '';
    });
    var inputClassName = computed(function () {
      return {
        'form-control': true,
        'input-element': true,
        'is-invalid': hasError.value || hasServerError.value
      };
    });
    var wrapperClassName = computed(function () {
      return {
        'form-group': true,
        'has-error': hasError.value || serverError.value,
        'input-highlight': defaultvalue.value !== value.value && reset.value // Highlight element if a defaultvalue is present

      };
    });
    var labelClassName = computed(function () {
      return additionalLabelClasses.value + ' ' + (hasError.value || serverError.value ? 'text-danger' : '');
    });
    var labelText = computed(function () {
      return label.value + (required.value ? '*' : '') + (isPublic.value ? '' : ' - <span class="text-muted">Diese Daten werden nicht veröffentlicht.</span>');
    });
    var idInput = computed(function () {
      return prefixId.value + '-textarea-' + name.value;
    });
    var idErrorText = computed(function () {
      return prefixId.value + '-textarea-' + name.value + '-error';
    });
    var showResetButton = computed(function () {
      return defaultvalue.value !== value.value && reset.value;
    }); //+----------------------------+
    //|     Lifecycle hooks        |
    //+----------------------------+

    onMounted(function () {
      var inp = textareainput.value;

      if (inp) {
        inp.oninvalid = inp.setCustomValidity(error.value);
      }

      onTextEntered({
        target: inp
      });
    }); //+---------------------+
    //|    return           |
    //+---------------------+

    return {
      // Computed
      hasError: hasError,
      hasServerError: hasServerError,
      wrapperClassName: wrapperClassName,
      labelClassName: labelClassName,
      inputClassName: inputClassName,
      idInput: idInput,
      idErrorText: idErrorText,
      labelText: labelText,
      showResetButton: showResetButton,
      // Listener
      onTextEntered: onTextEntered,
      // Other methods
      toggleHelpText: toggleHelpText,
      resetTextArea: resetTextArea,
      handleBlur: handleBlur,
      // Variables
      shouldShowHelp: shouldShowHelp,
      errorMessage: errorMessage,
      value: value,
      remainingMinCount: remainingMinCount,
      remainingMaxCount: remainingMaxCount,
      warnMinTextlimit: warnMinTextlimit,
      warnMaxTextlimit: warnMaxTextlimit
    };
  }
};

var _withScopeId = function _withScopeId(n) {
  return pushScopeId("data-v-69fd9d00"), n = n(), popScopeId(), n;
};

var _hoisted_1 = ["for", "aria-label"];
var _hoisted_2 = {
  class: "alert alert-info alert-dismissible mb-2 form-info-message",
  role: "alert"
};
var _hoisted_3 = {
  key: 2,
  class: "remaining-characters"
};
var _hoisted_4 = {
  key: 0,
  "aria-hidden": "true"
};
var _hoisted_5 = {
  key: 0,
  class: "visually-hidden"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = ["id", "aria-invalid", "aria-describedby", "data-vv-as", "data-wdw-code", "name", "required", "rows", "maxlength", "minlength", "readonly"];
var _hoisted_9 = ["id"];
var _hoisted_10 = ["id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return $props.visibleIfResult ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass($setup.wrapperClassName),
    id: "wdw-library-form-control-textarea"
  }, [withDirectives(createElementVNode("label", {
    for: $setup.idInput,
    class: normalizeClass($setup.labelClassName),
    "aria-label": $props.label
  }, null, 10, _hoisted_1), [[_directive_dompurify_html, $setup.labelText]]), $setup.showResetButton ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "btn-danger delete-filter",
    title: "Eingabe verwerfen",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.resetTextArea && $setup.resetTextArea.apply($setup, arguments);
    })
  }, " ✕ ")) : createCommentVNode("", true), $props.help ? (openBlock(), createElementBlock("span", {
    key: 1,
    class: "help-trigger",
    title: "Hilfe anzeigen",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: "question-circle",
    size: "lg"
  })])) : createCommentVNode("", true), withDirectives(createElementVNode("div", _hoisted_2, [withDirectives(createElementVNode("span", null, null, 512), [[_directive_dompurify_html, $props.help]]), createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "aria-label": "Close",
    onClick: _cache[2] || (_cache[2] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  })], 512), [[vShow, $setup.shouldShowHelp]]), $props.textLimitConfig.showRemainingCharactersInfo ? (openBlock(), createElementBlock("div", _hoisted_3, [$setup.remainingMaxCount ? (openBlock(), createElementBlock("span", _hoisted_4, [withDirectives(createElementVNode("span", null, toDisplayString($setup.remainingMaxCount) + " / " + toDisplayString($props.textLimitConfig.maxCount) + " Zeichen verfügbar ", 513), [[vShow, $setup.remainingMaxCount]]), $setup.remainingMaxCount ? (openBlock(), createElementBlock("span", _hoisted_5, toDisplayString($setup.remainingMaxCount) + " von " + toDisplayString($props.textLimitConfig.maxCount) + " Zeichen verfügbar ", 1)) : createCommentVNode("", true)])) : createCommentVNode("", true), _hoisted_6, $setup.remainingMinCount ? (openBlock(), createElementBlock("span", _hoisted_7, [withDirectives(createElementVNode("span", null, " Bitte noch mindestens " + toDisplayString($setup.remainingMinCount) + " Zeichen eingeben ", 513), [[vShow, $setup.remainingMinCount > 0]])])) : createCommentVNode("", true)])) : createCommentVNode("", true), withDirectives(createElementVNode("textarea", {
    id: $setup.idInput,
    ref: "textareainput",
    onKeyup: _cache[3] || (_cache[3] = function ($event) {
      return $setup.onTextEntered($event);
    }),
    "aria-invalid": $setup.hasError || $setup.hasServerError,
    "aria-describedby": $setup.idErrorText,
    "data-vv-as": $setup.labelText,
    "data-wdw-code": $props.code,
    name: $props.name,
    required: $props.required,
    rows: $props.rows,
    maxlength: $props.textLimitConfig.maxCount === 0 ? 524288 : $props.textLimitConfig.maxCount,
    minlength: $props.textLimitConfig.minCount,
    class: normalizeClass($setup.inputClassName),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $setup.value = $event;
    }),
    tabindex: "0",
    onBlur: _cache[5] || (_cache[5] = function () {
      return $setup.handleBlur && $setup.handleBlur.apply($setup, arguments);
    }),
    readonly: $props.readonly
  }, null, 42, _hoisted_8), [[vModelText, $setup.value]]), withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    class: "text-danger form-error-message"
  }, toDisplayString($props.error), 9, _hoisted_9), [[vShow, $setup.hasError]]), withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    class: "text-danger form-error-message"
  }, toDisplayString($props.serverError), 9, _hoisted_10), [[vShow, $setup.hasServerError]]), withDirectives(createElementVNode("span", {
    class: normalizeClass($props.textLimitConfig.textLimitClass)
  }, toDisplayString($props.textLimitConfig.cLimitMinText), 3), [[vShow, $props.textLimitConfig.cLimitMinText && $setup.warnMinTextlimit]]), withDirectives(createElementVNode("span", {
    class: normalizeClass($props.textLimitConfig.textLimitClass)
  }, toDisplayString($props.textLimitConfig.cLimitMaxText), 3), [[vShow, $props.textLimitConfig.cLimitMaxText && $setup.warnMaxTextlimit]])], 2)) : createCommentVNode("", true);
}

script.render = render;
script.__scopeId = "data-v-69fd9d00";

export { script as s };
